// extracted by mini-css-extract-plugin
export default {"cls1":"CookieConsent-AnchorLink_cls1__2zroS","cls2":"CookieConsent-AnchorLink_cls2__LxCdj CookieConsent-AnchorLink_cls1__2zroS"};